import React from "react";
import { Form, Checkbox } from "antd";
import styled from "styled-components";

import colors from "constants/palette";
import NumberInput from "components/inputs/NumberInput";

export default function SimpleProduct({ form, initialValue, customLabel }) {
  return (
    <Container key="1">
      {/* <h2 style={{ margin: "20px 0 12px 0" }}>محصول ساده :</h2> */}
      <Label>قیمت {customLabel}:</Label>
      <Form.Item
        name="price"
        rules={[
          {
            required: true,
            message: "لطفا قیمت را وارد کنید!",
          },
        ]}
      >
        <NumberInput style={{ width: "100%" }} currency />
      </Form.Item>
      <Label>قیمت تخفیف {customLabel} :</Label>
      <Form.Item
        name="off_price"
        // rules={[
        //   {
        //     required: true,
        //     message: "لطفا قیمت تخفیف را وارد کنید!",
        //   },
        // ]}
      >
        <NumberInput style={{ width: "100%" }} currency />
      </Form.Item>
    </Container>
  );
}

const Container = styled.div`
  text-align: start;

  & .item {
    padding: 7px;
    border-radius: 4px;
    margin-bottom: 8px;
    border: 1px dashed #d5d5d5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > span:first-child {
      border-left: 1px solid #d5d5d5;
    }
    > span {
      width: calc(50% - 18px);
      display: inline-flex;
    }

    & .delete {
      color: red;
      margin-right: auto;
      font-size: 18px;
      cursor: pointer;
      padding: 2px 8px;
      width: 36px;
    }
  }
`;
const InputContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  & > div {
    width: 49%;
    height: 50px;
    margin-top: 0;
    input,
    .ant-input-affix-wrapper {
      height: 40px;
      padding: 0 11px 0 0 !important;
    }
  }
  button {
    width: 100%;
    height: 38px;
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  & .ant-radio-button-wrapper-checked span {
    background-color: ${colors.primary};
  }
`;
const Label = styled.label`
  margin-bottom: 10px;
  display: block;
  color: ${colors.dark};
`;
